export enum OfferService {
  PMR = 'office_handicap_access',
  PETS_ALLOWED = 'petsAllowed',
  ERP = 'erp',
  PRIVATE_MEETING_ROOM = 'office_private_meeting_room',
  ARTIFICIAL_LIGHT = 'artificial',
  OUTSIDE = 'outside',
  OFFICE_BADGE_ACCESS = 'office_badge_access',
  OFFICE_FULL_TIME_ACCESS = 'office_full_time_access',
  OFFICE_PARKING = 'office_parking',
  OFFICE_PAYABLE_PARKING = 'office_payable_parking',
  OFFICE_FREE_PARKING = 'office_free_parking',
  OFFICE_BIKE_PARKING = 'office_bike_parking',

  SHARED_MEETING_ROOMS_COUNT = 'shared_meeting_rooms_count',
  HAS_PRIVATE_MEETING_ROOM = 'has_private_meeting_room',
  HAS_ACTUALLY_MEETING_ROOM = 'has_actually_meeting_room',
  PHONEBOX_COUNT = 'phonebox_count',
  PHONEBOXES_NULLABLE = 'phoneboxes_nullable',
  HAS_FULL_TIME_ACCESS = 'has_full_time_access',

  HAS_PHONE_BOX = 'has_phone_box',
  OFFICE_SHARE_MEETING_ROOM = 'office_shared_meeting_room',
  OFFICE_PAYABLE_MEETING_ROOM = 'office_payable_meeting_room',
  WIFI = 'wifi',
  FIBER = 'fiber',
  RJ45 = 'RJ45',
  OFFICE_DEDICATED_NETWORK = 'office_dedicated_network',
  ACCESS_SERVER = 'access_server',
  OFFICE_WAITING_ROOM = 'office_waiting_room',
  OFFICE_RELAXATION_AREA = 'office_relaxation_area',
  OFFICE_KITCHEN = 'office_kitchen',
  OFFICE_CAFETERIA = 'office_cafeteria',
  OFFICE_DOMICILIATION = 'office_domiciliation',
  OFFICE_HOUSEHOLD = 'office_household',
  OFFICE_AC = 'office_ac',
  OFFICE_TABLES_CHAIRS = 'office_tables_chairs',
  EMPTY = 'empty',
  OFFICE_STORAGE_POINT = 'office_storage_point',
  OFFICE_INDIVIDUAL_STORAGE = 'office_individual_storage',
  OFFICE_LOCKER = 'office_locker',
  OFFICE_VIDEO_PROJECTOR = 'office_video_projector',
  OFFICE_SCANNER = 'office_scanner',
  OFFICE_PHOTOCOPIER = 'office_photocopier',
  OFFICE_PRINTER = 'office_printer',
  OFFICE_TV = 'office_tv',
  OFFICE_MAIL = 'office_mail',
  OFFICE_RECEPTIONIST = 'office_receptionist',
  OFFICE_SEPARATE_ENTRANCE = 'office_separate_entrance',

  // Deal udur services
  MEETING_ROOM = 'shared_meeting_room',
  PRIVATE_PHONE_BOX = 'private_phone_box',
  PARKING = 'parking',
  SHOWER = 'shower',
  GYM = 'gym',
}
